import script from "./UpCarNatur.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpCarNatur.vue?vue&type=script&lang=ts&setup=true"

import "./UpCarNatur.vue?vue&type=style&index=0&id=3515ce96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3515ce96"]])

export default __exports__